import {
  CHECK_QUERY_PARAMS,
  CLEAR_QUERY_PARAMS_URL,
  GET_QUERY_PARAMS,
  GET_TOTAL_COUNT,
  INITIAL_CAR_FILTERS,
  INITIAL_SITE_FILTERS,
  UPDATE_ALL_DYNAMIC_FILTERS,
  UPDATE_CAR_FILTERS,
  UPDATE_CURRENT_QUERY,
  UPDATE_CARS,
  UPDATE_CARS_TIMESTAMP,
  UPDATE_TOTAL_COUNT,
  UPDATE_SITES,
  UPDATE_ARTICLES,
  UPDATE_CURRENT_CAR,
  UPDATE_FILTER_CHOICES,
  UPDATE_FILTER_CHOICES_RANGE,
  UPDATE_QUERY_PARAMS_URL,
  UPDATE_SITE_FILTERS,
  UPDATE_TIMES_SEARCHED_FILTERS,
  GET_CARS,
  GET_CARS_TIMESTAMP,
  GET_SITES,
  GET_ARTICLES,
  RANGE_FILTERS_MIN_MAX_VALUES,
  GET_RANGE_FILTERS_MIN_MAX_VALUES,
  INITIAL_ARTICLE_FILTERS,
} from './types';
import {
  canHaveNestedPage,
  getFilterItemLabel,
  getFilterItemValue,
  getMaxValue,
  getMaybeParentKey,
  getMinValue,
  getNestedPageKey,
  getPageType,
  hasItemAsString,
} from '../../../Project/bavaria-no/components/Filter/utils';
import withDefault from '../../../Project/bavaria-no/utils/withDefault';
import checkQueryParams, {
  replaceQueryWindowState,
  updateQueryString,
} from '@hedinbil/hedin-ui/dist/shop/utils/queryParams';
import { filterParamsToChosenFacets } from '../../../Project/bavaria-no/components/Filter/filterParamsToChosenFacets';
import { sortSitesByName } from '../helpers/sortSitesByName';
import {
  getDefItemFiltersKey,
  getItemFiltersKey,
  getItemsKey,
  getUpdateItemFiltersAction,
} from '../helpers/filterItems';

const addFieldsToObjects = (item, key, filterType) => {
  const hasNestedItems = canHaveNestedPage(key);
  const newParentItem = { ...item, activeFilters: 0 };
  const isCarList = filterType === 'Car';

  const array = !isCarList
    ? newParentItem.options
    : newParentItem[getNestedPageKey(withDefault(key, Object.keys(newParentItem)[0]))];

  return (array || []).map((filterItem) => {
    const value = !isCarList
      ? filterItem.key
      : getFilterItemValue(withDefault(key, Object.keys(filterItem)[0]), filterItem);
    const label = !isCarList
      ? filterItem.value
      : getFilterItemLabel(withDefault(key, Object.keys(filterItem)[0]), filterItem);

    if (hasItemAsString(withDefault(key, Object.keys(filterItem)[0]))) {
      return {
        label,
        value,
        chosen: false,
      };
    } else {
      const newItem = {
        ...filterItem,
        label,
        value,
        chosen: false,
      };

      if (hasNestedItems) {
        return {
          ...newItem,
          [getNestedPageKey(Object.keys(filterItem)[0])]: addFieldsToObjects(
            filterItem,
            Object.keys(filterItem)[0],
            filterType
          ),
          activeFilters: 0,
        };
      }

      return newItem;
    }
  });
};

const getChosenItems = (item, key, filterType) => {
  const hasNestedItems = canHaveNestedPage(key);
  const nestedPageKey = filterType === 'Car' ? getNestedPageKey(Object.keys(item)[0]) : 'options';

  return item[nestedPageKey]
    .filter((filterItem) => {
      const newItem = { ...filterItem };

      return newItem.chosen === true;
    })
    .map((filterItem) => {
      const newItem = { ...filterItem };
      const chosenNestedArray = [];

      if (hasNestedItems && filterType === 'Car') {
        newItem[getNestedPageKey(Object.keys(newItem)[0])].filter((nestedItem) => {
          if (nestedItem.chosen === true) {
            chosenNestedArray.push(nestedItem);
          }
          return nestedItem.chosen === true;
        });
      }

      const nestedKey =
        filterType === 'Car' ? getNestedPageKey(Object.keys(filterItem)[0]) : 'options';

      if (chosenNestedArray.length > 0) {
        return {
          ...newItem,
          [nestedKey]: chosenNestedArray,
        };
      } else {
        return {
          ...newItem,
        };
      }
    });
};

const getChosenFacets = (filters, filterType) => {
  return [...filters].map((item) => {
    if (getPageType(item.key) === 'range') {
      return {
        ...item,
      };
    } else {
      return {
        key: item.key,
        subKey: item.subKey ? item.subKey : null,
        options: getChosenItems(
          item,
          withDefault(getMaybeParentKey(item.key), Object.keys(item)[0]),
          filterType
        ),
      };
    }
  });
};

const separateNestedChosenFacets = (chosenFilters, filterType) => {
  const array = [];
  const nestedKeysAdded = []; // we need to bundle the nested keys to the same object

  chosenFilters.map((item) => {
    const hasNestedItems = filterType === 'Car' && canHaveNestedPage(item.key);

    array.push(item);

    if (hasNestedItems) {
      item.options.map((filterItem) => {
        const nestedArray = [];
        filterItem[getNestedPageKey(Object.keys(filterItem)[0])].map((nestedItem) => {
          if (nestedItem.chosen) {
            nestedArray.push(nestedItem);
          }
        });

        const nestedKey = item.subKey; // brandId, regionId is set here!

        if (nestedKeysAdded.indexOf(nestedKey) === -1) {
          array.push({
            key: nestedKey,
            options: [...nestedArray],
          });
          nestedKeysAdded.push(nestedKey); // Add to nestedKeysAdded array as the key have now been pushed to array
        } else {
          array.map((item) => {
            if (item.key === nestedKey) {
              item.options = [...item.options, ...nestedArray]; // merge arrays
            }
            return item;
          });
        }
      });
    }
  });

  return array;
};

const chosenFacetsToArray = (facet) => {
  return facet.options.map((item) => item.value);
};

const getChosenFacetsQueryParams = (chosenFilters, url, filterType) => {
  const seperatedChosenFacets = separateNestedChosenFacets(chosenFilters, filterType);
  const keysValues = seperatedChosenFacets.map((item) => {
    if (getPageType(item.key) === 'range') {
      return { ...item };
    } else {
      return { [item.key]: chosenFacetsToArray(item) };
    }
  });

  let queryParams = url;

  keysValues.map((item) => {
    const facetData = item[Object.keys(item)[0]];
    if (facetData.length > 0) {
      if (getPageType(item.key) === 'range') {
        // If the chosen value is the same as max value then make it infinite.
        const maxValue =
          getMaxValue(item.key, item.maxValue) === item.chosenMaxValue ? -1 : item.chosenMaxValue;
        if (
          item.chosenMinValue !== getMinValue(item.key, item.minValue) ||
          item.chosenMaxValue !== getMaxValue(item.key, item.maxValue)
        ) {
          queryParams = updateQueryString(
            item.key,
            `${item.chosenMinValue},${maxValue}`,
            queryParams
          );
        }
      } else {
        queryParams = updateQueryString(Object.keys(item)[0], facetData.join(','), queryParams);
      }
    }
  });

  return queryParams;
};

const clearChosenFilter = (filters) => {
  return [...filters].map((item) => {
    const hasPageTypeRange = getPageType(item.key);

    if (hasPageTypeRange === 'range') {
      return {
        ...item,
        chosenMinValue: Number(getMinValue(item.key, item.minValue)),
        chosenMaxValue: getMaxValue(item.key, item.maxValue),
        activeFilters: 0,
      };
    } else {
      const newItem = { ...item };

      newItem.options = newItem.options.map((filterItem) => {
        if (canHaveNestedPage(item.key)) {
          filterItem[getNestedPageKey(withDefault(filterItem.key, Object.keys(filterItem)[0]))] =
            filterItem[
              getNestedPageKey(withDefault(filterItem.key, Object.keys(filterItem)[0]))
            ].map((nestedItem) => {
              nestedItem.chosen = false;

              return { ...nestedItem, activeFilters: 0 };
            });
        }
        filterItem.chosen = false;

        return { ...filterItem, activeFilters: 0 };
      });

      return {
        ...newItem,
        activeFilters: 0,
      };
    }
  });
};

export const filterActions =
  (type, value, args = null) =>
  (dispatch, getState) => {
    const reduxFieldState = { ...getState() };
    const { key, parentValue, filterType } = args || {};
    const itemsFilterKey = getItemFiltersKey(filterType);
    const maybeSearchValue = checkQueryParams('s');
    switch (type) {
      case GET_RANGE_FILTERS_MIN_MAX_VALUES:
        return reduxFieldState.filter.rangeValues.find((item) => item.key === value);

      case RANGE_FILTERS_MIN_MAX_VALUES:
        const rangeFacets = value
          .filter((item) => getPageType(item.key) === 'range')
          .map((item) => ({
            key: item.key,
            title: item.title,
            rangeMin: getMinValue(item.key, item.minValue),
            rangeMax: getMaxValue(item.key, item.maxValue),
          }));

        dispatch({
          type: RANGE_FILTERS_MIN_MAX_VALUES,
          payload: {
            rangeValues: rangeFacets,
          },
        });
        break;

      case INITIAL_CAR_FILTERS:
        dispatch({
          type: INITIAL_CAR_FILTERS,
          payload: {
            carFilters: [...value].map((item) => {
              const hasPageTypeRange = getPageType(item.key);

              if (hasPageTypeRange === 'range') {
                return {
                  ...item,
                  chosenMinValue: Number(getMinValue(item.key, item.minValue)),
                  chosenMaxValue: getMaxValue(item.key, item.maxValue),
                };
              } else {
                return {
                  ...item,
                  options: addFieldsToObjects(item, item.key, filterType),
                  activeFilters: 0,
                };
              }
            }),
          },
        });
        break;

      case UPDATE_CARS:
        dispatch({
          type: UPDATE_CARS,
          payload: {
            cars: [...value],
          },
        });
        break;

      case UPDATE_CARS_TIMESTAMP:
        dispatch({
          type: UPDATE_CARS_TIMESTAMP,
          payload: {
            timeStamp: new Date(),
          },
        });
        break;

      case UPDATE_TOTAL_COUNT:
        dispatch({
          type: UPDATE_TOTAL_COUNT,
          payload: {
            totalCount: {
              sites: filterType === 'Site' ? value : reduxFieldState.filter.totalCount.sites,
              cars: filterType === 'Car' ? value : reduxFieldState.filter.totalCount.cars,
              articles:
                filterType === 'Article' ? value : reduxFieldState.filter.totalCount.articles,
            },
          },
        });
        break;

      case UPDATE_SITES:
        dispatch({
          type: UPDATE_SITES,
          payload: {
            sites: [...value],
          },
        });
        break;

      case UPDATE_ARTICLES:
        dispatch({
          type: UPDATE_ARTICLES,
          payload: {
            articles: [...value],
          },
        });
        break;

      case UPDATE_ALL_DYNAMIC_FILTERS:
        const oldFilters = [...reduxFieldState.filter[itemsFilterKey]];

        const newDynamicFilters = [...value]
          .map((item) => {
            const hasPageTypeRange = getPageType(item.key);

            if (hasPageTypeRange === 'range') {
              return {
                ...item,
                chosenMinValue: Number(getMinValue(item.key, item.minValue)),
                chosenMaxValue: getMaxValue(item.key, item.maxValue),
              };
            } else {
              return {
                ...item,
                options: addFieldsToObjects(item, item.key, filterType),
                activeFilters: 0,
              };
            }
          })
          .map((item) => {
            (oldFilters || []).map((oldItem) => {
              if (oldItem?.key === item?.key) {
                const hasPageTypeRange = getPageType(item.key);
                if (hasPageTypeRange === 'range') {
                  if (oldItem.chosenMinValue !== getMinValue(oldItem.key, oldItem.minValue)) {
                    item.chosenMinValue = Number(oldItem.chosenMinValue);
                  }
                  if (oldItem.chosenMaxValue !== getMaxValue(oldItem.key, oldItem.maxValue)) {
                    item.chosenMaxValue = Number(oldItem.chosenMaxValue);
                  }
                } else {
                  let parentActiveFiltersCount = 0;

                  const nestedPageKey =
                    filterType === 'Car'
                      ? getNestedPageKey(withDefault(item?.key, Object.keys(item)[0]))
                      : 'options';

                  const oldNestedPageKey =
                    filterType === 'Car'
                      ? getNestedPageKey(withDefault(oldItem?.key, Object.keys(oldItem)[0]))
                      : 'options';

                  item[nestedPageKey] = (item[nestedPageKey] || []).map((nestedItem) => {
                    let nestedActiveFiltersCount = 0;

                    oldItem[oldNestedPageKey].map((oldNestedItem) => {
                      if (nestedItem?.value === oldNestedItem?.value) {
                        nestedItem.chosen = oldNestedItem.chosen;

                        if (oldNestedItem.chosen) {
                          parentActiveFiltersCount += 1;
                        }
                      }

                      if (canHaveNestedPage(item.key)) {
                        nestedItem[
                          getNestedPageKey(withDefault(nestedItem?.key, Object.keys(nestedItem)[0]))
                        ].map((nestedNestedItem) => {
                          oldNestedItem[
                            getNestedPageKey(
                              withDefault(oldNestedItem?.key, Object.keys(oldNestedItem)[0])
                            )
                          ].map((oldNestedNestedItem) => {
                            if (nestedNestedItem?.value === oldNestedNestedItem?.value) {
                              nestedNestedItem.chosen = oldNestedNestedItem.chosen;

                              if (nestedNestedItem.chosen) {
                                nestedActiveFiltersCount += 1;
                              }
                            }
                          });

                          return { ...nestedNestedItem };
                        });
                      }
                    });
                    nestedItem.activeFilters = nestedActiveFiltersCount;

                    const isRegionFilter =
                      getNestedPageKey(withDefault(nestedItem?.key, Object.keys(nestedItem)[0])) ===
                      'sites';

                    if (isRegionFilter) {
                      const sortedList = sortSitesByName(nestedItem.sites);
                      nestedItem.sites = sortedList;
                    }

                    return { ...nestedItem };
                  });

                  item.activeFilters = parentActiveFiltersCount;
                }
              }
            });

            return { ...item };
          });

        // If there's a new Page that have reset the currentQuery then skip update Redux state.
        if (reduxFieldState.filter.currentQuery !== '') {
          dispatch({
            type: UPDATE_ALL_DYNAMIC_FILTERS,
            payload: {
              [itemsFilterKey]: newDynamicFilters,
              filterType: [itemsFilterKey],
            },
          });
        }
        break;

      case INITIAL_SITE_FILTERS:
        dispatch({
          type: INITIAL_SITE_FILTERS,
          payload: {
            siteFilters: [...value].map((item) => {
              return {
                ...item,
                options: addFieldsToObjects(item, item.key, filterType),
                activeFilters: 0,
              };
            }),
          },
        });
        break;

      case INITIAL_ARTICLE_FILTERS:
        dispatch({
          type: INITIAL_ARTICLE_FILTERS,
          payload: {
            articleFilters: [...value].map((item) => {
              return {
                ...item,
                options: addFieldsToObjects(item, item.key, filterType),
                activeFilters: 0,
              };
            }),
          },
        });
        break;

      case UPDATE_FILTER_CHOICES:
        const arrayToUpdate = [...reduxFieldState.filter[itemsFilterKey]];

        const filters = [...arrayToUpdate].map((item) => {
          const keyCondition =
            filterType === 'Car' ? item?.key && item?.key === getMaybeParentKey(key) : item?.key;
          if (keyCondition) {
            const nestedItemsKey = 'options';
            let chosenFilters = 0;

            return {
              ...item,
              [nestedItemsKey]: item[nestedItemsKey].map((filterItem) => {
                let nestedChosenFilters;
                // Find the item that we clicked on and that it's not a nested item
                const nestedCondition =
                  filterType === 'Car'
                    ? getMaybeParentKey(key) === key && filterItem.value === value
                    : filterItem.value === value;

                if (nestedCondition) {
                  // Check if it could have nested items (if parent is toggled, so is the child)
                  if (canHaveNestedPage(withDefault(key, Object.keys(item)[0]))) {
                    filterItem.chosen = !filterItem.chosen;
                    filterItem[getNestedPageKey(Object.keys(filterItem)[0])].map((nestedItem) => {
                      if (!filterItem.chosen) {
                        nestedItem.chosen = filterItem.chosen;
                      }
                    });
                  } else {
                    filterItem.chosen = !filterItem.chosen;
                  }
                } else {
                  if (filterItem.value === parentValue) {
                    filterItem[getNestedPageKey(Object.keys(filterItem)[0])].map((nestedItem) => {
                      if (nestedItem.value === value) {
                        nestedItem.chosen = !nestedItem.chosen;
                      }
                    });
                    const chosenNestedItems = filterItem[
                      getNestedPageKey(Object.keys(filterItem)[0])
                    ].filter((nestedItem) => nestedItem.chosen);

                    // If no nested items are chosen, update parent to not be toggled.
                    filterItem.chosen = chosenNestedItems.length !== 0;
                  }
                }

                const chosenNestedItems = (
                  filterItem[getNestedPageKey(Object.keys(filterItem)[0])] || []
                ).filter((nestedItem) => nestedItem.chosen);

                nestedChosenFilters = chosenNestedItems.length;
                if (filterItem.chosen) chosenFilters += 1;

                return { ...filterItem, activeFilters: nestedChosenFilters };
              }),
              activeFilters: chosenFilters,
            };
          } else {
            return item;
          }
        });

        dispatch({
          type: getUpdateItemFiltersAction(filterType),
          payload: {
            [itemsFilterKey]: [...filters],
            currentQuery: getChosenFacetsQueryParams(
              getChosenFacets(filters, filterType),
              '___', // to not get any real URL
              filterType
            ),
          },
        });
        break;

      case UPDATE_FILTER_CHOICES_RANGE:
        if (!key && !value) break;
        // If the filter type is Range then
        const newFilters = [...reduxFieldState.filter[itemsFilterKey]].map((item) => {
          const newItem = { ...item };
          if (newItem?.key === key) {
            newItem.chosenMinValue = Number(value.min);
            newItem.chosenMaxValue = Number(value.max);
          }

          return newItem;
        });

        dispatch({
          type: getUpdateItemFiltersAction(filterType),
          payload: {
            [itemsFilterKey]: [...newFilters],
            currentQuery: getChosenFacetsQueryParams(
              getChosenFacets(newFilters, filterType),
              '___', // to not get any real URL
              filterType
            ),
          },
        });

        break;

      case UPDATE_QUERY_PARAMS_URL:
        // Clear filters that already set.
        window.history.replaceState(null, null, window.location.pathname);

        const maybePageNumber = parentValue;
        const maybeSorting = key;

        const arrayToFilter = reduxFieldState.filter[itemsFilterKey];

        const chosenFilters = getChosenFacets(arrayToFilter, filterType);
        let newQueryParams = getChosenFacetsQueryParams(
          chosenFilters,
          window.location.href,
          filterType
        );

        const hasQuery = newQueryParams !== window.location.origin + window.location.pathname;
        const newSortingFakeURL = updateQueryString('so', maybeSorting, '__');
        let extraParams = '';

        if (maybePageNumber) {
          extraParams = updateQueryString('page', maybePageNumber, newSortingFakeURL).replace(
            '__',
            ''
          );
        } else {
          extraParams = newSortingFakeURL.replace('__', '');
        }

        if (maybeSearchValue) {
          extraParams += '&s=' + maybeSearchValue;
        }

        if (hasQuery) {
          newQueryParams = newQueryParams + extraParams.replace('?', '&');
        } else {
          newQueryParams = newQueryParams + extraParams;
        }

        replaceQueryWindowState(newQueryParams);
        break;

      case CLEAR_QUERY_PARAMS_URL:
        const queryObj = {};
        const clearEventType = getUpdateItemFiltersAction(filterType);

        const clearChosenFilterResult = clearChosenFilter(
          reduxFieldState.filter[getDefItemFiltersKey(filterType)]
        );

        queryObj[getItemFiltersKey(filterType)] =
          filterType === 'Car' ? [...clearChosenFilterResult] : clearChosenFilterResult;

        dispatch({
          type: clearEventType,
          payload: {
            ...queryObj,
          },
        });
        replaceQueryWindowState(window.location.pathname);
        break;

      case CHECK_QUERY_PARAMS:
        const obj = {};

        const eventType = getUpdateItemFiltersAction(filterType);

        obj[itemsFilterKey] = filterParamsToChosenFacets(
          reduxFieldState.filter[itemsFilterKey],
          key
        );

        dispatch({
          type: eventType,
          payload: {
            ...obj,
          },
        });

        break;

      case GET_QUERY_PARAMS:
        const paramsArray = reduxFieldState.filter[itemsFilterKey];

        const result = getChosenFacetsQueryParams(
          getChosenFacets(paramsArray, filterType),
          '___', // to not get any real URL
          filterType
        )
          .replace('___', '')
          .replace('?', '');

        if (maybeSearchValue) {
          return result + '&s=' + maybeSearchValue;
        }

        return result;

      case UPDATE_CURRENT_QUERY:
        dispatch({
          type: UPDATE_CURRENT_QUERY,
          payload: {
            currentQuery: value,
          },
        });

        break;

      case GET_CARS:
        return reduxFieldState.filter.cars;

      case GET_TOTAL_COUNT:
        return reduxFieldState.filter.totalCount[getItemsKey(filterType)];

      case GET_CARS_TIMESTAMP:
        return reduxFieldState.filter.timeStamp;

      case GET_SITES:
        return reduxFieldState.filter.sites;

      case GET_ARTICLES:
        return reduxFieldState.filter.articles;

      case UPDATE_TIMES_SEARCHED_FILTERS:
        dispatch({
          type: type,
          payload: {
            timesSearched: value,
          },
        });

        break;

      case UPDATE_CURRENT_CAR:
        dispatch({
          type: type,
          payload: {
            currentCar: value,
          },
        });
        break;

      default:
        break;
    }
  };
